import { render, staticRenderFns } from "./chart-num.vue?vue&type=template&id=07335a54&"
import script from "./chart-num.vue?vue&type=script&lang=ts&"
export * from "./chart-num.vue?vue&type=script&lang=ts&"
import style0 from "./chart-num.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports